import React from "react"
import { Breakpoint, useCurrentWidth } from "react-socks"
import Img from "gatsby-image"

import { PricingHeader, PricingPrice } from "../typography"
import {
  TableItem,
  PlanContainer,
  PlanHeader,
  TitleHeader,
  DropdownButton,
  PricingHeaderLeft,
  PlanBody,
  PlanButton,
  PlanIllustration,
  TableFeatures,
} from "./styled"
import FeatureList from "./tableFeatures"
// import illustrationEnum from "./tableIllustration"
import { breakpoints } from "../../utils/styleVariables"
import { ReactComponent as Dropdown } from "../../images/dropdown.svg"
import PriceComponent from "./priceComponent"

const HeaderContent = ({
  title,
  storage,
  sub,
  opened,
  price,
  priceStep,
  discount,
  shouldOpenable,
}) => (
  <>
    <TitleHeader
      direction="vertical"
      valign="center"
      width={shouldOpenable ? "auto" : "100%"}
      shouldOpenable
    >
      <PricingHeader>{title}</PricingHeader>
      <Breakpoint mobile down>
        <PriceComponent price={price && price[priceStep]} discount={discount} />
      </Breakpoint>
    </TitleHeader>
    <Breakpoint tablet up>
      <PricingHeaderLeft>
        {storage}
        <div className="sub">{sub}</div>
      </PricingHeaderLeft>
    </Breakpoint>
    <Breakpoint mobile down>
      {shouldOpenable && (
        <DropdownButton opened={opened}>
          <Dropdown />
        </DropdownButton>
      )}
    </Breakpoint>
  </>
)

const PlanItem = ({
  planFeatures,
  image,
  plan,
  opened,
  index,
  handleOpened,
  baseWidth = "100%",
  tabletWidth,
  desktopWidth,
  style,
  shouldOpenable,
  priceStep,
  link,
  periods,
}) => {
  const { services, slug, button, price, discount, storage, sub, title } = plan
  const available = {}
  const unavailable = {}
  const isTablet = useCurrentWidth() < breakpoints.tablet
  const localOpened = isTablet ? opened : true
  // const handleClick = isTablet ? () => handleOpened(index) : () => null

  Object.keys(planFeatures).forEach(feature => {
    if (!!services[feature] === true) available[feature] = services[feature]
    else unavailable[feature] = services[feature]
  })

  return (
    <TableItem
      width={baseWidth}
      tabletWidth={tabletWidth}
      tablet={{ width: "third" }}
      desktopWidth={desktopWidth}
      style={style}
    >
      <PlanContainer valign="center" direction="vertical">
        <PlanHeader onClick={() => handleOpened(index)}>
          <HeaderContent
            title={title}
            storage={storage}
            sub={sub}
            opened={opened}
            price={price}
            priceStep={priceStep}
            discount={discount}
            shouldOpenable={shouldOpenable}
          />
        </PlanHeader>
        <PlanBody opened={localOpened} valign="center" direction="vertical">
          <Breakpoint tablet up>
            {image && (
              <PlanIllustration>
                <Img fluid={image.fluid} />
              </PlanIllustration>
            )}
          </Breakpoint>
          <TableFeatures>
            <FeatureList
              features={planFeatures}
              services={available}
              slug={slug}
            />
            <FeatureList features={planFeatures} services={unavailable} />
          </TableFeatures>
          <PlanHeader>
            <PlanButton
              text={button.text}
              name={button.text}
              maxWidth="100px"
              slug={slug}
              icon="basket"
              to={
                button.to &&
                `${link}?plan=${button.to}&period=${periods[priceStep]}`
              }
            />
            <Breakpoint tablet up>
              <PriceComponent
                price={price && price[priceStep]}
                discount={discount}
              />
            </Breakpoint>
          </PlanHeader>
        </PlanBody>
      </PlanContainer>
    </TableItem>
  )
}

export default PlanItem
